import { CloseIcon } from "@chakra-ui/icons";
import { Box } from "@chakra-ui/react";
import styled from "@emotion/styled";

export const DropText = styled.div`
  position: absolute;
  opacity: 0;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transition: opacity 300ms;
`;

export const DropZone = styled(Box)`
  position: relative;
  background-color: var(--chakra-colors-neutral-200);
  border-width: 4px;
  border-style: solid;
  border-color: transparent;
  box-sizing: border-box;
  transition: 300ms ease;

  &.canDrop {
    background: var(--chakra-colors-primary-200);
    border-color: var(--chakra-colors-primary-500);
    cursor: grabbing;

    >div {
      opacity: .5;
      color: var(--chakra-colors-primary-500);
    }
  }

  &.invalidDrop {
    background: var(--chakra-colors-danger-200);
    border-color: var(--chakra-colors-danger-500);
    cursor: not-allowed;
  }
`;

export const HiddenInput = styled.input`
  display: none;
`;

export const RemoveFile = styled(CloseIcon)`
  cursor: pointer;
  height: 1em;
  position: absolute;
  right: .5em;
  top: .5em;

  > path:only-child {
    fill: var(--chakra-colors-danger-600);
  }
`;